import { type SearchableJob } from '@/features/jobs/list/SearchableJob'
import { type CallCenterJobSummary } from './call-center-job-summary'

export function mapSearchableJobToCallCenterJobSummary(
  job: SearchableJob,
): CallCenterJobSummary {
  return {
    id: job.id,
    shortId: job.shortId,
    name: job.displayName,
    total: job.total,
    workspace: job.workspace,
    status: job.status,
    jobScopeItems: job.jobScopeItems || [],
    dateCreated: job.dateCreated,
    legendId: job.legendId,
    legendVersion: job.legendVersion,
  }
}
